module.exports = __webpack_public_path__ + "static/img/4.fb86e137.png";